var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"flex-box"},[_c('p',[_vm._v("アークナイツ オペレーターランダム編成")]),_c('Menu'),_c('a',{staticClass:"last-item",attrs:{"href":_vm.adminInfo.siteUrl}},[_vm._v("サイトトップ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }